<script lang="ts" setup>
import { addProtocol } from '@/js/utils/url';
import Button from '@ui/components/forms/button.vue';

export interface SidebarColumnInterface {
    index?: number;
    column?: {
        header?: string;
        lines?: [
            {
                key?: string;
                url?: string;
                value?: string;
            },
        ];
        button?: {
            url?: string;
            text?: string;
            target?: string;
        };
    };
}
const props = withDefaults(defineProps<SidebarColumnInterface>(), {
    index: null,
    column: () => {
        return {
            header: '',
            lines: [
                {
                    key: '',
                    url: '',
                    value: '',
                },
            ],
            button: {
                url: '',
                text: '',
                target: '',
            },
        };
    },
});
</script>
<template>
    <div class="xs:pl-0 flex flex-col gap-3 px-5 md:px-8">
        <h2
            v-if="props.column.header"
            class="font-brand m-0 pt-5 text-base font-bold leading-7 text-black lg:text-lg"
            :class="[props.index === 0 && 'pr-28 xs:pr-0 lg:pr-28'].join(' ')"
        >
            {{ props.column.header }}
        </h2>
        <div
            v-if="column.lines"
            class="space-y-2"
        >
            <div
                v-for="(line, idx) in props.column.lines"
                :key="idx"
                class="xs:flex-row xs:flex-nowrap xs:space-x-2 flex flex-col"
            >
                <div
                    v-if="line.key"
                    class="xs:w-24 xs:flex-shrink-0 xs:text-base text-sm text-gray-400 lg:w-1/3"
                >
                    {{ line.key }}
                </div>
                <template v-if="line.url">
                    <a
                        class="text-brand-500 xs:flex-grow block min-w-0 break-all text-base font-medium"
                        :href="addProtocol(line.url)"
                    >
                        {{ line.url }}
                    </a>
                </template>
                <template v-else>
                    <div
                        :class="line.key && 'font-medium'"
                        class="xs:min-w-0 xs:flex-grow text-base text-gray-800"
                    >
                        {{ line.value }}
                    </div>
                </template>
            </div>

            <template v-if="column.button">
                <div class="pt-2">
                    <Button
                        :href="column.button.url"
                        :target="column.button.target"
                        theme="primary"
                        class="xs:max-w-xs w-full"
                    >
                        {{ column.button.text }}
                    </Button>
                </div>
            </template>
        </div>
    </div>
</template>
